// ** React Imports
import React from 'react'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

const UICustomization: React.FC<{}> = () => {
  const router = useRouter()

  useEffect(() => {
    if (router.pathname === '/style') {
      router.replace('/style/elements')
    }
  }, [router])

  return <></>
}

export default UICustomization
